import { RemoteNbs } from "../../../../data/usecases/nbs/remote-nbs";
import { Nbs } from "../../../../domain/models/nbs";
import { makeAxiosHttpClient } from "../../http/axios-http-client-factory";

export const makeRemoteNbs = (): Nbs =>
  new RemoteNbs("/nbs", makeAxiosHttpClient());
